export const generateCsvStringInternal = (columnConfig, data) => {
  if (!columnConfig || !data) {
    return '';
  }

  const exportColumns = columnConfig.filter(col => col.key !== 'checked');

  if (!exportColumns.length) {
    return '';
  }

  const headers = exportColumns.map(
    col => `"${String(col.label ?? '').replace(/"/g, '""')}"`,
  );
  const headerString = headers.join(',');

  const rowStrings = data.map(row => {
    const cells = exportColumns.map(col => {
      let value = row[col.key];

      if (col.formatter && typeof col.formatter === 'function') {
        value = col.formatter(value);
      }

      const stringValue =
        value !== null && value !== undefined ? String(value) : '';
      return `"${stringValue.replace(/"/g, '""')}"`;
    });
    return cells.join(',');
  });

  return [headerString, ...rowStrings].join('\n');
};

export const downloadCsv = (columnConfig, data, filename) => {
  const csvString = generateCsvStringInternal(columnConfig, data);

  if (!csvString) {
    return false;
  }

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  }

  return false;
};
